import Actions from '../actions/actionTypes';

const initialState = {
  content: [],
  totalElements: 0,
  totalPages: 0,
  page: 0,
  size: 10,
  fetching: true,
  selected: [],
  updating: null,
  currentTest: null
};

function tests(state = initialState, action) {
  switch (action.type) {
    case Actions.SAVE_TESTS:
      return { ...state, ...action.tests };
    case Actions.SAVE_TEST:
      return { ...state, currentTest: action.test };
    case Actions.TESTS_FETCHING:
      return { ...state, fetching: action.payload };
    case Actions.TEST_SELECTED:
      if (state.selected.includes(action.payload)) {
        return { ...state, selected: state.selected.filter(item => item !== action.payload) };
      } else {
        return { ...state, selected: [...state.selected, action.payload] };
      }
    case Actions.TESTS_DELETED:
      return { ...state, selected: [] };
    case Actions.CHANGE_PAGE:
      return { ...state, page: action.page };
    case Actions.CHANGE_PAGE_SIZE:
      return { ...state, size: action.rowsPerPage };
    case Actions.TEST_FOR_UPDATE:
      return { ...state, updating: action.payload };
    default:
      return state;
  }
}

export default tests;
